import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Controller, RegisterOptions } from "react-hook-form"
import { IDropdownControllerProps, IGenericControllerProps, IInputStringControllerProps, IMultiSelectControllerProps } from "../../../interfaces/contollers";

export const InputStringController = (props: IInputStringControllerProps) => {
    const rules: RegisterOptions = {
        required: props.item.properties.required,
        maxLength: props.item.properties.max,
        minLength: props.item.properties.min,
    }

    rules.pattern = props.item.properties.specialCharacters === false ? /^[a-zA-Z0-9 ]+$/g : undefined;

    if (props.item.properties.unique === true && props.uniquenessValidationFunction != null) {
        rules.validate = value => {
            if (props.uniquenessValidationFunction != null) {
                return props.uniquenessValidationFunction(value);
            }
            else {
                return true;
            }
        };
    }

    return <Controller
        control={props.control}
        rules={rules}
        render={({ field: { onChange, onBlur, value, name, ref } }) => {
            return <input
                ref={ref}
                type='string'
                name={name}
                value={value}
                minLength={props.item.properties.min}
                maxLength={props.item.properties.max}
                required={props.item.properties.required}
                onChange={onChange}
                onBlur={onBlur}
                disabled={props.disabled}
            />;
        }}
        name={props.item.name}
        defaultValue={props.getDefaultValue(props.item.name, props.item.default)}
        shouldUnregister={true}
    />
}

export const InputNumberController = (props: IGenericControllerProps) => {
    const rules: RegisterOptions = {
        required: props.item.properties.required,
        max: props.item.properties.max,
        min: props.item.properties.min,
    }

    return <Controller
        control={props.control}
        rules={rules}
        render={({ field: { onChange, onBlur, value, name, ref } }) => {
            return <input
                ref={ref}
                type='number'
                name={name}
                value={value}
                min={props.item.properties.min}
                max={props.item.properties.max}
                required={props.item.properties.required}
                onChange={onChange}
                onBlur={onBlur}
                disabled={props.disabled}
            />;
        }}
        name={props.item.name}
        defaultValue={props.getDefaultValue(props.item.name, props.item.default)}
        shouldUnregister={true}
    />
}

export const DropdownController = (props: IDropdownControllerProps) => {
    const rules: RegisterOptions = {
        required: props.item.properties.required,
    }

    return <Controller
        control={props.control}
        rules={rules}
        render={({ field: { onChange, onBlur, value, name, ref } }) => {
            let validatedValue = props.checkDropdownValue(props.item.name, value, props.item.depends);
            return <DropDownList
                ref={ref}
                name={name}
                className={props.className}
                popupSettings={props.popupSettings}
                value={validatedValue}
                onChange={onChange}
                onBlur={onBlur}
                filterable={false}
                size={'large'}
                rounded={'full'}
                fillMode={'outline'}
                disabled={props.disabled}
                required={props.item.properties.required}
                {...props.getDropdownProps(props.item.name)}
            />;
        }}
        name={props.item.name}
        defaultValue={props.getDefaultValue(props.item.name, props.item.default)}
        shouldUnregister={true}
    />
}

export const MultiselectController = (props: IMultiSelectControllerProps) => {
    const rules: RegisterOptions = {
        required: props.item.properties.required,
    }

    return <Controller
        control={props.control}
        rules={rules}
        render={({ field: { onChange, onBlur, value, name, ref } }) => {
            let validatedValue = props.checkMultiSelectValue(props.item.name, value, props.item.depends);
            return <MultiSelect
                ref={ref}
                name={name}
                className={props.className}
                popupSettings={props.popupSettings}
                value={validatedValue}
                onChange={onChange}
                onBlur={onBlur}
                filterable={false}
                size={null}
                rounded={'full'}
                fillMode={'outline'}
                disabled={props.disabled}
                required={props.item.properties.required}
                {...props.getMultiSelectProps(props.item.name)}
            />;
        }}
        name={props.item.name}
        defaultValue={props.getDefaultValue(props.item.name, props.item.default)}
        shouldUnregister={true}
    />
}